<template>
  <section id="calculator" class="calculator-section section">
    <div class="shell calculator-layout">
      <div class="calculator-heading">
        <span class="eyebrow">НАЧНЁМ С ВАШЕГО ОБЪЕКТА</span>
        <h2>
          Ваша задача<br />Ваш масштаб<br /><span class="gradient-text">Ваш Robotics Vision</span>
        </h2>
        <p>Несколько деталей — и предварительная конфигурация уже перед вами.</p>
        <span class="calculator-note"
          >Окончательную стоимость определяем<br />после знакомства с объектом.</span
        ><NuxtLink
          v-if="showPlannerLink"
          to="/calculator#planner"
          class="text-link"
          @click="prepare"
          >Разместить камеры на плане</NuxtLink
        >
      </div>
      <div class="calculator">
        <fieldset>
          <legend>Где нужно видеонаблюдение?</legend>
          <div class="choice-row object-choices">
            <label v-for="item in objects" :key="item.value"
              ><input
                v-model="selection.object"
                type="radio"
                name="object"
                :value="item.value"
              /><span>{{ item.label }}</span></label
            >
          </div>
        </fieldset>
        <div class="service-option">
          <div class="service-card" :class="{ 'is-selected': selection.service }">
            <label class="service-choice">
              <span
                ><strong>Сопровождение системы</strong
                ><small>Удалённая диагностика и помощь</small></span
              >
              <input
                v-model="selection.service"
                type="checkbox"
                role="switch"
                aria-label="Добавить сопровождение системы"
                aria-controls="estimate-service-price"
              /><span class="switch-ui" aria-hidden="true" />
            </label>
            <p
              v-if="selection.service"
              id="estimate-service-price"
              class="service-estimate"
              role="status"
            >
              {{ servicePrice }}
            </p>
          </div>
        </div>
        <div class="estimate" aria-live="polite" aria-atomic="true">
          <span>{{
            selection.cameras === 'custom'
              ? 'Оборудование и монтаж'
              : `${cameraLabel(Number(selection.cameras))} · оборудование и монтаж`
          }}</span
          ><output :class="{ 'custom-estimate': !pack }">{{ price }}</output>
          <p>
            {{
              pack
                ? `${selection.includeArchive ? archiveSummary : 'Без архива'} · ${selection.includeRouter ? 'новый роутер' : 'свой роутер'} · примерный монтаж включён.`
                : 'Подберём оборудование после обследования объекта'
            }}
          </p>
          <p v-if="pack && !pending && !error">
            Оборудование: {{ formatPrice(pack.subtotal) }} · Работы:
            {{ formatPrice(pack.installationTotal) }}
          </p>
          <button v-if="error" type="button" class="text-link" @click="refresh()">
            Повторить загрузку цен
          </button>
          <NuxtLink v-if="pack" to="/calculator#planner" class="text-link" @click="prepare"
            >Посмотреть состав и изменить проект</NuxtLink
          >
        </div>
        <NuxtLink to="/contacts?subject=estimate" class="button button-primary">
          Оставить заявку на установку
        </NuxtLink>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import { cameraLabel } from '~/utils/project';
withDefaults(defineProps<{ showPlannerLink?: boolean }>(), { showPlannerLink: true });
const { selection, pack, price, servicePrice, prepare, pending, error, refresh, archiveSummary } =
  useEstimate();
const objects = [
  { value: 'business', label: 'Бизнес' },
  { value: 'home', label: 'Дом' },
  { value: 'warehouse', label: 'Склад' },
];
</script>
